export default __webpack_public_path__ + "static/media/file.e0af0938.svg";